import * as Data from 'effect/Data';

/**
 * Errors that are caused by "faulty" form declarations, e.g.:
 * - Template References with non-existent field-refs
 * - `value` of a field does not match with the expected types
 */
export class FormDeclarationError extends Data.TaggedError(
  'FormDeclarationError',
)<{ readonly message: string }> {}
